import { FC } from "react";
import { Loader } from "rsuite";
import { formatDateTime } from "../../../../util/date";
import { Link } from "react-router-dom";
import { AppTimestamp } from "../../../../domain/app/Timestamp";
import { DashboardDataTimestamp } from "./data-timestamp";
import { UserVehicleControl } from "../../../../domain/control/Vehicle";

type Props = {
  dataLoading?: boolean;
  data?: UserVehicleControl[];
  timestamp?: AppTimestamp;
  onRefreshClicked: () => void;
};

export const DashboardLastVehicleList: FC<Props> = ({
  dataLoading,
  data,
  timestamp,
  onRefreshClicked,
}) => {
  if (dataLoading === true) {
    return (
      <div className={"w-full h-full flex justify-center items-center"}>
        <Loader size={"md"} />
      </div>
    );
  }
  if (!data || data.length <= 0) {
    return (
      <div
        className={"w-full h-full p-2 md:p-4 flex items-center justify-center"}
      >
        <DashboardDataTimestamp
          position={"tr"}
          timestamp={timestamp}
          loading={dataLoading}
          onRefreshButtonClicked={onRefreshClicked}
        />
        <span className={"text-lg font-normal text-neutral-700"}>
          No se han registrado ingresos vehiculares hoy.
        </span>
      </div>
    );
  }
  return (
    <div
      className={
        "w-full h-full flex flex-col justify-between items-center relative"
      }
    >
      <DashboardDataTimestamp
        position={"tr"}
        timestamp={timestamp}
        loading={dataLoading}
        onRefreshButtonClicked={onRefreshClicked}
      />

      <span className={"text-lg font-semibold text-neutral-800 mt-6"}>
        Registros de Ingreso Vehicular
      </span>
      <div
        className={
          "flex-1 flex flex-col w-full overflow-y-auto overflow-x-hidden divide-y divide-neutral-300 scrollbar-hide md:scrollbar-default"
        }
      >
        {data.map((patrol) => (
          <div
            className={
              "w-full p-2 flex flex-row gap-2 items-center justify-start"
            }
            key={patrol.reference}
          >
            <div className={"w-20 h-20 shrink-0 overflow-hidden"}></div>
            <div className={"flex flex-col"}>
              <span className={"text-sm font-semibold text-neutral-900"}>
                {patrol.owner?.displayName || patrol.ownerUid}
              </span>
              <span className={"text-xs font-normal text-neutral-700"}>
                {formatDateTime(new Date(patrol.timestamp))}
              </span>
            </div>
          </div>
        ))}
        <Link to={"/dashboard/vehicle-control-group"}>
          <div
            className={
              "w-full py-2 flex justify-center items-center bg-neutral-100 rounded-b-lg"
            }
          >
            <span className={"text-neutral-600"}>Ver más...</span>
          </div>
        </Link>
      </div>
    </div>
  );
};
